import React, { Component } from 'react';
import {connect} from 'react-redux';

import FileSaver from 'file-saver';

import { Row, Col, Button, Table, Tooltip, Popconfirm,
Modal } from 'antd';

import CommonForm from '@common/components/form';
import DocSpan from '@common/components/DocSpan';


import format from '@common/utils/formatters/_';


import InfrastrutturaServices from '@accreditamento/services/Infrastruttura';
import CreateAudiovisivo from '@accreditamento/forms/completeRequest/infrastruttura/audiovisivi/Create';
import UpdateAudiovisivo from '@accreditamento/forms/completeRequest/infrastruttura/audiovisivi/Update';

const getTipoAula = (component, record) => {
  try {
    let type = format.replaceStub(record.id_tab_tipo_aula, 'tipo_aula', component.props.GlobalStore)

    return type;
  } catch(e) {
    console.error(e)
    return 'errore'
  }
}

const getAule = (component, value) => {
  return <p>
    {
      value.map(el => {
        return <span key={"aula_"+el.id} style={{display: 'inline-block'}}><strong>{el.nome_aula}</strong> - { getTipoAula(component, el) } </span>
      })
    }
  </p>
}


const columns = (component) => {
  return [{
        title: 'Ausili',
        dataIndex: 'ausili',
        render: (text, record) => (<div style={{width: 180}}>{record.ausili}</div>),
    }, {
        title: 'Quantità',
        dataIndex: 'quantita',
        //key: 'quantita',
        render: (text, record) => (<div style={{width: 60}}>{record.quantita}</div>)
    }, {
        title: 'Aule',
        dataIndex: 'aule',
        //key: 'mesi_disponibilita',
        render: (text, record) => (<div style={{width: 300}}>{getAule(component, record.aule)}</div>)

    },
    {
        title: 'Azioni',
        dataIndex: 'azione',
        key: 'azione',
        render: (text, record) => (
            <div style={{width: 80}}>
                <Tooltip placement="top" title={component.props.readOnly ? "Dettagli" : "Modifica"}>
                  <Button className="m2w" size="small" shape="circle" icon={component.props.readOnly ? "eye" : "edit"} onClick={() => component.editAudiovisivo(record)} />
                </Tooltip>
                <Popconfirm disabled={component.props.readOnly} placement="leftTop" title="Sicuro di voler rimuovere questa aula?"
                onConfirm={() => component.deleteAudiovisivo(record.id)} okText="Si" cancelText="No">
                  <Button disabled={component.props.readOnly} loading={component.state.deleting_id === record.id} className="m2w" size="small" shape="circle" icon="delete" />
                </Popconfirm>
            </div>
        ),
    }]
}


const uploadFormLayout = (component) => {
return {
    layout: 'vertical',
    multistep: false,
    rows: [
      {
        cols: [
          {
            items: [
              {
                type: 'simple_upload',
                name: 'dragger',
                accept: '.p7m,.pdf',
                action: '/', // url upload
                listType: 'text', // text,picture,picture-card
                multiple: false,
                fileList: 'fileListProp', // funzione che ritorna la lista dei file correntemente caricati
                customRequest: 'customUploadRequest', // sovrascrive upload
                onRemove: 'onRemove', // funzione richiamata alla cancellazione del file
                text: "Carica lista p7m o pdf firmato",
                props: {
                  disabled: component.props.readOnly,
                  showUploadList: false
                }
              },
            ],
          },
        ],
      },
    ],
    onSubmit: 'submitted',
  };
}


class Audiovisivi extends Component {

  state = {
    loading: false,
    audiovisivi: [],
    show_add: false,
    adding: false,
    show_edit: false,
    editing: false,
    editing_element: null,
    deleting: false,
    deleting_id: null,
    media_file: null
  };



  componentDidMount() {
    this.setState({loading: true, media_file: this.props.sede.media.find(el => el.tipo.sottodominio === 'autocertificazione_audiovisivi')});
    setTimeout(()=>{
      InfrastrutturaServices.listAudiovisivo(
        this.props.accreditamento.id, this.props.sede.enteSede.id, (res) => {
        this.setState({loading: false, audiovisivi: res.data.data })
      }, () => this.setState({loading: false}) )
    }, 200)

  }

  createAudiovisivo(data, file){
    if(!this.state.adding) {
      this.setState({loading: true, adding: true});

      InfrastrutturaServices.addAudiovisivo(
        this.props.accreditamento.id,
        this.props.sede.enteSede.id,
        data,
        (res) => {
          if(this.props.onAdd) this.props.onAdd(res.data.data);
          this.setState({
            loading: false,
            adding: false,
            show_add: false,
            audiovisivi: [...this.state.audiovisivi, res.data.data]
          })
      }, () => this.setState({loading: false, adding: false}) )

    }
  }

  editAudiovisivo(element) {
    this.setState({
      show_edit: true,
      editing_element: element
    })
  }

  updateAudiovisivo(data, file){
    if(!this.state.editing) {
      this.setState({loading: true, editing: true});

      InfrastrutturaServices.editAudiovisivo(
        this.props.accreditamento.id,
        this.props.sede.enteSede.id,
        this.state.editing_element.id,
        data,
        (res) => {
          if(this.props.onEdit) this.props.onEdit(res.data.data);
          this.setState({loading: false, editing: false, show_edit: false,
            audiovisivi: this.state.audiovisivi.map(el => {
            return (el.id === this.state.editing_element.id) ? res.data.data : el
          })
        })
      }, () => this.setState({editing: false, loading: false}) )

    }
  }

  deleteAudiovisivo(id) {
    if(!this.state.deleting) {

      this.setState({loading: true, deleting: true, deleting_id: id});
      InfrastrutturaServices.deleteAudiovisivo( this.props.accreditamento.id, this.props.sede.enteSede.id, id, () => {
        if(this.props.onDelete) this.props.onDelete(id);
        this.setState({loading: false, deleting: false, deleting_id: null, audiovisivi: this.state.audiovisivi.filter(el=>el.id !== id)})
      }, () => this.setState({loading: false, deleting: false, deleting_id: null }) )

    }

  }


  saveBlob(blob) {
    const _blob = new Blob([blob], { type: 'application/pdf' });
    const today = new Date();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    const date = today.getDate();
    const hour = ('0' + today.getHours()).slice(-2);
    const minu = ('0' + today.getMinutes()).slice(-2);
    let nome_file = `audiovisivi_${date}${month}${year}_${hour}${minu}.pdf`;
    FileSaver.saveAs(_blob, nome_file);

    this.setState({loading: false, downloading: false});

  }

  uploadAudiovisivi(file) {
    if(!this.state.loading) {
      this.setState({
        loading: true
      }, () => {
        InfrastrutturaServices.uploadAudiovisivi(
          this.props.accreditamento.id,
          this.props.sede.id_ente_sede, {
          filename: 'file'
        }, { file: file, name: file.name, chiave: 'file'}, (res) => {

          if(this.props.onAdd) this.props.onAdd({})
          this.setState({ loading: false, media_file: res.data.data });

        }, () => this.setState({ loading: false }))
      })

    }
  }

  render() {
    return (
      <div>
        <Table
        columns={columns(this)}
        loading={this.state.loading}
        dataSource={this.state.audiovisivi}
        rowKey={(record)=>record.id}
        />

        <Button
          style={{marginTop: 16}}
          onClick={()=>this.setState({show_add: !this.state.show_add})}
          type='primary'
          disabled={this.props.readOnly}
        >
          Inserisci una nuova attrezzatura audio/video
        </Button>

        <h4 style={{marginTop: 16}}>Autocertificazione</h4>
        <p>Quando ritieni di aver completato l&apos;inserimento dei materiali audiovisivi, scarica il file con la lista, firmalo digitalmente e ricaricalo per autocertificare i dati inseriti</p>
        <Row>
          <Col span={6}>
            <Button
              loading={this.state.downloading}
              disabled={this.state.loading || this.props.readOnly}
              className="m5h" type="primary" icon="file" onClick={() => {
                if(!this.state.loading) {
                  this.setState({
                    loading: true,
                    downloading: true
                  }, () => {

                    InfrastrutturaServices.downloadAudiovisivi(
                      this.props.accreditamento.id,
                      this.props.sede.id_ente_sede,
                      (res) => this.saveBlob(res.data),
                      () => this.setState({loading: false, downloading: false})
                    )

                  })
                }

              }}>Scarica lista</Button>
          </Col>
          <Col span={6}>
            <CommonForm
              wrappedComponentRef={inst => (this.formRef = inst)}
              loading={this.state.loading || false}
              form_model={uploadFormLayout(this)}
              values={{
              }}
              fileListProp={() => []}
              customUploadRequest={obj => {
                this.uploadAudiovisivi(obj.file);
              }}
            />
            {
              this.state.media_file ?
                <div key={this.state.media_file.id}><p style={{ display: 'inline-block' }}>lista firmata: </p><DocSpan key={this.state.media_file.id} file={this.state.media_file} /></div>
              : null
            }
          </Col>
        </Row>

        <Modal
          visible={this.state.show_add}
          onOk={() => this.setState({show_add: false})}
          okButtonProps={{style: {display: 'none'}}}
          width={800}
          destroyOnClose={true}
          onCancel={()=>this.setState({show_add: false})}
        >
          <CreateAudiovisivo
            loading={this.state.adding}
            GlobalStore={this.props.GlobalStore}
            accreditamento={this.props.accreditamento}
            sede={this.props.sede}
            onSubmit={(data, file)=>this.createAudiovisivo(data, file)}
            readOnly={this.props.readOnly}
          />
        </Modal>
        <Modal
          visible={this.state.show_edit}
          onOk={() => this.setState({show_edit: false})}
          okButtonProps={{style: {display: 'none'}}}
          width={800}
          destroyOnClose={true}
          onCancel={()=>this.setState({show_edit: false})}
        >
          <UpdateAudiovisivo
            loading={this.state.editing}
            GlobalStore={this.props.GlobalStore}
            values={this.state.editing_element}
            sede={this.props.sede}
            accreditamento={this.props.accreditamento}
            onSubmit={(data, file)=>this.updateAudiovisivo(data, file)}
            readOnly={this.props.readOnly}
          />
        </Modal>
      </div>
    );
  }
}
export default connect(({GlobalStore})=>({GlobalStore}))(Audiovisivi);